export default function safeParse(json: string) {
  let parsed;
  try {
    parsed = JSON.parse(json);
  } catch {}

  return parsed;
}
